<template>
  <b-card
    class="earnings-card"
  >
    <b-row>
      <b-col cols="6">
        <b-card-title class="mb-1">
          Balance
        </b-card-title>
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="CheckIcon"
                class="mr-75 text-success"
              />
              <span
                class="font-weight-bold text-success"
              >Amount Balance</span>
            </th>
            <td class="pb-50 font-weight-bold text-success">
              {{ balanceStatistics.amount }}
            </td>
          </tr>
        </table>
      </b-col>

    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BCardTitle,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardTitle,
  },
  props: {
    balanceStatistics: {
      type: Object,
      default: () => {},
    },
  },

}
</script>
